import { useContext, useEffect, useState } from 'react';
import { UserContext } from '../../context/UserContext';
import { DialogContext } from '../../context/DialogContext';
import { TestingHqContext } from '../../context/TestingHqContext';
import { TestingContext } from '../../context/TestingContext';
import { get_testing_place_list, get_testing_list, upsert_testing_place, get_place_list } from '../../utils/restapi';
import { getCurrentRegularTesting } from '../../utils/currentTesting';
import { TESTING_PLACE_ISUSE } from '../../constants/testing_place';
import './joins.css';
import ListBody from '../../components/list/ListBody';
import ImageView from '../image_view';

const TestingPlaceJoins = () => {
  const { user } = useContext(UserContext);
  const { openDialog, closeDialog } = useContext(DialogContext);
  const { testingHqs } = useContext(TestingHqContext);
  const { testingObj, setTestingObj } = useContext(TestingContext);

  // 선택상자 목록들
  const [testingTypes, setTestingTypes] = useState([]);
  const [testings, setTestings] = useState([]);

  // 알림 메세지
  const [alertMessage, setAlertMessage] = useState('시험을 선택해 주세요.');

  // 목록
  const [items, setItems] = useState([]);
  const [editingPlaceIds, setEditingPlaceIds] = useState([]);
  const [submittingPlaceIds, setSubmittingPlaceIds] = useState([]);
  
  // 정렬 관련 상태
  const [sort, setSort] = useState('');
  const [desc, setDesc] = useState('');

  const [keyword, setKeyword] = useState('');

  // 자동완성 관련 상태
  const [searchResults, setSearchResults] = useState([]);
  const [showAutocomplete, setShowAutocomplete] = useState(false);
  const [selectedPlace, setSelectedPlace] = useState(null);

  const getPlaceId = (item) => item.place_id || item.placeObj?.place_id;
  const isUsedPlace = (item) => parseInt(item?.isUse, 10) === TESTING_PLACE_ISUSE.field.used;
  const isJoinRequestedPlace = (item) => parseInt(item?.isUse, 10) === TESTING_PLACE_ISUSE.field.join;
  const isEditingPlace = (item) => editingPlaceIds.includes(getPlaceId(item));
  const isSubmittingPlace = (item) => submittingPlaceIds.includes(getPlaceId(item));
  const getPendingUpdate = (item) => item?.data?.pending_update || null;
  const getStatusLabel = (item) => {
    const baseLabel = TESTING_PLACE_ISUSE.name[item.isUse] || '-';
    return getPendingUpdate(item) ? `${baseLabel} (수정요청)` : baseLabel;
  };

  // headers에 renderCell 함수를 포함시킴
  const headers = [
    { 
      name: 'NO.', 
      value: 'a_place_id',
      renderCell: (item, index) => index + 1
    },
    { 
      name: '지역본부', 
      value: 'a_gcode',
      renderCell: (item) => item.placeObj.gcode
    },
    { 
      name: '장소명칭', 
      value: 'a_name',
      renderCell: (item) => item.placeObj.name
    },
    { 
      name: '주소', 
      value: 'a_addressMain',
      renderCell: (item) => `${item.placeObj.addressMain} ${item.placeObj.addressDetail}`
    },
    { 
      name: '약도', 
      value: '',
      renderCell: (item) => item.map ? (
        <button 
          onClick={() => handleMapClick(item)}
          style={{ 
            background: 'none', 
            border: 'none', 
            color: '#007bff', 
            textDecoration: 'underline', 
            cursor: 'pointer' 
          }}
        >
          약도
        </button>
      ) : console.log(item)
    },
    { 
      name: '최대접수가능인원', 
      value: '',
      renderCell: (item) => (
        isUsedPlace(item) && !isEditingPlace(item)
          ? <span>{item.maxCount ?? 0}</span>
          : <input 
              type="number" 
              value={item.maxCount ?? 0} 
              onChange={(e) => handleMaxCountChange(item, e.target.value)}
              onFocus={(e) => e.target.select()}
              min="0"
            />
      )
    },
    { 
      name: '주차', 
      value: 'a_parking',
      renderCell: (item) => (
        isUsedPlace(item) && !isEditingPlace(item)
          ? <span>{item.parking_info || ''}</span>
          : <select
              value={item.parking_info || ''}
              onChange={(e) => handleParkingChange(item, e.target.value)}
            >
              <option value="">▒▒ 선택 ▒▒</option>
              <option value="주차가능">주차가능</option>
              <option value="주차공간협소(대중교통이용바람)">주차공간협소(대중교통이용바람)</option>
              <option value="주차불가">주차불가</option>
              <option value="유료주차(본인부담)">유료주차(본인부담)</option>
              <option value="주차공간협소(우천시주차불가)">주차공간협소(우천시주차불가)</option>
              <option value="주차가능(우천시주차불가)">주차가능(우천시주차불가)</option>
            </select>
      )
    },
    { 
      name: '상태', 
      value: '',
      renderCell: (item) => getStatusLabel(item)
    },
    {
      name: '작업',
      value: '',
      renderCell: (item) => (
        <div className="row-actions">
          {isUsedPlace(item) ? (
            getPendingUpdate(item) ? (
              <button
                className="cancel-btn"
                onClick={() => handleCancelPlace(item)}
                disabled={isSubmittingPlace(item)}
              >
                취소
              </button>
            ) : isEditingPlace(item) ? (
              <>
                <button
                  className="submit-btn"
                  onClick={() => handleApplyPlace(item)}
                  disabled={isSubmittingPlace(item)}
                >
                  신청
                </button>
                <button
                  className="cancel-btn secondary"
                  onClick={() => handleCancelEdit(item)}
                  disabled={isSubmittingPlace(item)}
                >
                  취소
                </button>
              </>
            ) : (
              <button
                className="edit-btn"
                onClick={() => handleEditPlace(item)}
                disabled={isSubmittingPlace(item)}
              >
                수정
              </button>
            )
          ) : isJoinRequestedPlace(item) ? (
            <button className="cancel-btn" onClick={() => handleCancelPlace(item)} disabled={isSubmittingPlace(item)}>취소</button>
          ) : (
            <button className="submit-btn" onClick={() => handleApplyPlace(item)} disabled={isSubmittingPlace(item)}>신청</button>
          )}
        </div>
      )
    }
  ];

  // 시험유형 데이터 가져오기 + 이번 회차 고정
  const getTestingTypes = async () => {
    console.log('getTestingTypes called');
    try {
      const { types, regularType, testing } = await getCurrentRegularTesting();
      setTestingTypes(types);

      if (!regularType?.code) {
        return;
      }

      if (!testing) {
        setTestings([]);
        setTestingObj(null);
        return;
      }

      setTestings([testing]);
      setTestingObj({ ...testing, type: regularType.code });
    } catch (error) {
      console.error("Error fetching types:", error);
    }
  };

  // 시험에 대한 데이터 가져오기
  const getTesting = async (type) => {
    console.log(`getTesting called : ${type}`);
    try {
      const response = await get_testing_list({ type, page:1, rowsPerPage:1000, sort:'a_testing_id', desc:'desc' });
      console.log("getTesting:", response);
      setTestings(response.lists || response);
    } catch (error) {
      console.error("Error fetching testing:", error);
      setTestings([]);
    }
  };

  // 고사장에 대한 데이터 가져오기
  const getTestingPlaces = async () => {
    console.log(`getTestingPlaces called`);

    const json = {
      person_id: user?.person_id || 0,
      testing_id: testingObj?.testing_id || 0,
      gcodes: testingHqs.map(hq => hq.code).join(','),
      page: 1,
      rowsPerPage: 10000,
      isAll: false
    };

    console.log("getTestingPlace params:", json);

    try {
      const response = await get_testing_place_list(json);
      console.log("getTestingPlaces:", response);
      // isUse=9(삭제)는 제외하고, place_id를 __pkValue__에 복사
      const itemsWithPk = (response.lists || response)
        .filter(item => parseInt(item.isUse) !== 9)
        .map(item => ({
          ...item,
          __pkValue__: getPlaceId(item),
          approvedMaxCount: item.maxCount ?? 0,
          approvedParkingInfo: item.parking_info || ''
        }));

      setItems(itemsWithPk);
      setEditingPlaceIds([]);
    } catch (error) {
      console.error("Error fetching place:", error);
      setItems([]);
      setEditingPlaceIds([]);
    }
  };

  // 시험유형 선택 핸들러
  const handleTestingTypeChange = (e) => {
    console.log('handleTestingTypeChange called');
    const selectedValue = e.target.value;
    setTestingObj({ ...testingObj, type: selectedValue });

    if (selectedValue) {
      getTesting(selectedValue);
    } else {
      setTestings([]);
    }
  };

  // 시험 선택 핸들러
  const handleTestingChange = (e) => {
    console.log('handleTestingChange called');
    const selectedValue = e.target.value;
    const selectedTesting = testings.find(obj => obj.testing_id === parseInt(selectedValue));
    setTestingObj(selectedTesting || null);
  };

  const handleEditPlace = (item) => {
    const placeId = getPlaceId(item);
    const pendingUpdate = getPendingUpdate(item);

    setItems(prevItems =>
      prevItems.map(i =>
        getPlaceId(i) === placeId
          ? {
              ...i,
              maxCount: pendingUpdate?.maxCount ?? i.approvedMaxCount ?? i.maxCount ?? 0,
              parking_info: pendingUpdate?.parking_info ?? i.approvedParkingInfo ?? i.parking_info ?? '',
              isModified: false,
            }
          : i
      )
    );

    setEditingPlaceIds(prev => (prev.includes(placeId) ? prev : [...prev, placeId]));
  };

  const handleCancelEdit = (item) => {
    const placeId = getPlaceId(item);

    setItems(prevItems =>
      prevItems.map(i =>
        getPlaceId(i) === placeId
          ? {
              ...i,
              maxCount: i.approvedMaxCount ?? i.maxCount ?? 0,
              parking_info: i.approvedParkingInfo ?? i.parking_info ?? '',
              isModified: false,
            }
          : i
      )
    );

    setEditingPlaceIds(prev => prev.filter(id => id !== placeId));
  };

  const handleApplyPlace = async (item) => {
    if (!testingObj || !testingObj.testing_id) {
      alert('시험을 먼저 선택해 주세요.');
      return;
    }

    const placeId = getPlaceId(item);
    const requestMaxCount = parseInt(item.maxCount, 10) || 0;
    const requestParkingInfo = item.parking_info || '';
    const placeObj = item.placeObj || {};

    setSubmittingPlaceIds(prev => [...prev, placeId]);

    try {
      if (isUsedPlace(item)) {
        const json = {
          testing_place_id: item.testing_place_id,
          data: {
            ...(item.data || {}),
            pending_update: {
              maxCount: requestMaxCount,
              parking_info: requestParkingInfo,
              requestedAt: new Date().toISOString(),
              requestedBy: {
                user_id: user?.user_id || 0,
                person_id: user?.person_id || 0,
              },
            },
          },
        };

        await upsert_testing_place(json);
        alert('수정 요청이 저장되었습니다. 관리자 승인 후 변경 내용이 반영됩니다.');
      } else {
        const json = {
          testing_id: testingObj.testing_id,
          place_id: placeId,
          user_id: user?.user_id || 0,
          person_id: user?.person_id || 0,
          gcode: placeObj.gcode,
          code: placeObj.code,
          name: placeObj.name,
          maxCount: requestMaxCount,
          parking_info: requestParkingInfo,
          isUse: TESTING_PLACE_ISUSE.field.join,
          data: {
            ...(item.data || {}),
            pending_update: null,
          },
        };

        if (item.testing_place_id) {
          json.testing_place_id = item.testing_place_id;
        }

        await upsert_testing_place(json);
        alert('사용 신청이 접수되었습니다.');
      }

      await getTestingPlaces();
    } catch (error) {
      console.error('Error applying testing place:', error);
      alert('처리 중 오류가 발생했습니다.');
    } finally {
      setSubmittingPlaceIds(prev => prev.filter(id => id !== placeId));
    }
  };

  // 정렬 변경
  const handleSortChange = (value, currentSort, setSort, setDesc) => {
    if (currentSort === value) {
      setDesc(desc === 'desc' ? 'asc' : 'desc');
    } else {
      setSort(value);
      setDesc('desc');
    }
  };

  // 사용요청 취소
  const handleCancelPlace = async (item) => {
    const pendingUpdate = getPendingUpdate(item);
    const placeId = getPlaceId(item);
    const confirmMessage = pendingUpdate
      ? `'${item.placeObj.name}' 고사장의 수정 요청을 취소하시겠습니까?\n취소하면 승인된 상태로 돌아갑니다.`
      : `'${item.placeObj.name}' 고사장의 사용 요청을 취소하시겠습니까?\n취소하면 해당 고사장이 목록에서 제거됩니다.`;

    if (!window.confirm(confirmMessage)) return;

    // 서버에 저장된 적 없는 항목은 로컬 상태에서만 제거
    if (!item.testing_place_id) {
      setItems(prev => prev.filter(i => getPlaceId(i) !== placeId));
      setEditingPlaceIds(prev => prev.filter(id => id !== placeId));
      alert('사용 요청이 취소되었습니다.');
      return;
    }

    if (!pendingUpdate && parseInt(item.isUse, 10) !== TESTING_PLACE_ISUSE.field.join) {
      alert('사용 요청 상태가 아닌 고사장입니다.');
      return;
    }

    const json = pendingUpdate
      ? {
          testing_place_id: item.testing_place_id,
          isUse: TESTING_PLACE_ISUSE.field.used,
          maxCount: item.approvedMaxCount ?? item.maxCount ?? 0,
          parking_info: item.approvedParkingInfo ?? item.parking_info ?? '',
          data: {
            ...(item.data || {}),
            pending_update: null,
          },
        }
      : {
          testing_place_id: item.testing_place_id,
          isUse: 9,
          data: {
            ...(item.data || {}),
            pending_update: null,
          },
        };

    try {
      await upsert_testing_place(json);
      setItems(prev => prev.filter(i => getPlaceId(i) !== placeId));
      setEditingPlaceIds(prev => prev.filter(id => id !== placeId));
      if (pendingUpdate) {
        await getTestingPlaces();
        alert('수정 요청이 취소되어 승인 상태로 복원되었습니다.');
      } else {
        alert('사용 요청이 취소되었습니다.');
      }
    } catch (error) {
      console.error('Error cancelling testing place:', error);
      alert('취소 처리 중 오류가 발생했습니다.');
    }
  };

  // 최대 접수 가능 인원 변경
  const handleMaxCountChange = (item, newValue) => {
    const maxCountValue = parseInt(newValue) || 0;
    const placeId = getPlaceId(item);
    
    setItems(prevItems => 
      prevItems.map(i => 
        getPlaceId(i) === placeId
          ? { ...i, maxCount: maxCountValue, isModified: true }
          : i
      )
    );
  };

  // 주차 정보 변경
  const handleParkingChange = (item, newValue) => {
    const placeId = getPlaceId(item);
    setItems(prevItems =>
      prevItems.map(i =>
        getPlaceId(i) === placeId
          ? { ...i, parking_info: newValue, isModified: true }
          : i
      )
    );
  };

  // 고사장 검색 자동완성
  const searchPlaces = async (searchKeyword) => {
    if (!searchKeyword || searchKeyword.trim() === '') {
      setSearchResults([]);
      setShowAutocomplete(false);
      return;
    }

    const json = {
      keyword: searchKeyword,
      page: 1,
      rowsPerPage: 100,
      gcodes: testingHqs.map(hq => hq.code).join(',')
    };

    try {
      const response = await get_place_list(json);
      setSearchResults(response.lists || response || []);
      setShowAutocomplete(true);
    } catch (error) {
      console.error('Error searching places:', error);
      setSearchResults([]);
    }
  };

  // 고사장 선택
  const handlePlaceSelect = (place) => {
    setSelectedPlace(place);
    setKeyword(place.name);
    setShowAutocomplete(false);
  };

  // 고사장 추가
  const handleAddPlace = async () => {
    if (!testingObj || !testingObj.testing_id) {
      alert('시험을 먼저 선택해 주세요.');
      return;
    }

    if (!selectedPlace) {
      alert('고사장을 선택해 주세요.');
      return;
    }

    // 이미 추가된 고사장인지 확인
    const exists = items.find(item => item.place_id === selectedPlace.place_id);
    if (exists) {
      alert('이미 추가된 고사장입니다.');
      return;
    }

    // items에만 추가 (임시 데이터)
    const newItem = {
      place_id: selectedPlace.place_id,
      testing_place_id: 0, // 아직 저장되지 않음
      placeObj: selectedPlace,
      map: selectedPlace.map || null,
      maxCount: 0,
      parking_info: '',
      isUse: TESTING_PLACE_ISUSE.field.unused,
      isNew: true, // 새로 추가된 항목 표시
      approvedMaxCount: 0,
      approvedParkingInfo: '',
      data: {},
      __pkValue__: selectedPlace.place_id
    };

    setItems(prevItems => [...prevItems, newItem]);
    
    alert('고사장이 추가되었습니다. 각 행의 신청 버튼으로 요청해 주세요.');
    setKeyword('');
    setSelectedPlace(null);
  };

  // 약도 이미지 다이얼로그 열기
  const handleMapClick = (item) => {
    console.log(item);
    const mapUrl = `https://www.klata.or.kr${item.map.url}`;
    const title = `${item.placeObj?.name || ''} 약도`;

    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
        border: 'none',
        borderRadius: '8px',
        maxWidth: '90vw',
        maxHeight: '90vh',
        overflow: 'auto'
      },
    };

    openDialog(
      <ImageView 
        title={title}
        url={mapUrl}
        onClose={closeDialog}
      />, 
      customStyles
    );
  };

  useEffect(() => {
    getTestingTypes();
    if (testingHqs.length) getTestingPlaces();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingHqs]);

  useEffect(() => {
    if (testingObj?.type && !testingObj?.testing_id) {
      getTesting(testingObj.type);
    } else {
      if (!testingObj?.type) {
        setTestings([]);
      }
    }
  }, [testingObj?.type, testingObj?.testing_id]);

  useEffect(() => {
    if (testingObj && testingObj.testing_id) {
      const msg = `${testingObj.title}에서 사용할 고사장을 검색해서 추가해 주세요.`;
      setAlertMessage(msg);
      getTestingPlaces();
    } else {
      const msg = `시험을 선택해 주세요.`;
      setAlertMessage(msg);
      setItems([]);
      setEditingPlaceIds([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingObj]);

  return (
    <div id="testing_place_joins">
      <div className="head">
        <h1>회차별 고사장 설정</h1>
      </div>
      <div className="body">
        <ul className="form">
          <li>
            <label>시험</label>
            <span>
              <select value={testingObj?.type || 0} onChange={handleTestingTypeChange} disabled>
                <option value="">▒ 구분 ▒</option>
                {testingTypes
                  .filter(obj => `${obj?.nickname || ''}${obj?.name || ''}`.includes('정기'))
                  .map((obj, index) => (
                  <option key={index} value={obj.code}>
                    {obj.nickname || obj.name}
                  </option>
                ))}
              </select>
              <select value={testingObj?.testing_id || 0} onChange={handleTestingChange} disabled>
                <option value="">▒ 시험 ▒</option>
                {testings.map((obj, index) => (
                  <option key={index} value={obj.testing_id}>
                    {obj.title}
                  </option>
                ))}
              </select>
            </span>
          </li>
        </ul>
        <div className="alert">
          {alertMessage}
        </div>
        <ul className="form">
          <li>
            <label>고사장 검색</label>
            <span className="autocomplete-container">
              <input 
                type="text" 
                value={keyword} 
                onChange={e => {
                  setKeyword(e.target.value);
                  searchPlaces(e.target.value);
                }} 
                onFocus={() => keyword && setShowAutocomplete(true)}
                onBlur={() => setTimeout(() => setShowAutocomplete(false), 200)}
                placeholder="고사장명을 입력해 주세요." 
              />
              {showAutocomplete && searchResults.length > 0 && (
                <div className="autocomplete-results">
                  {searchResults.map((place, index) => (
                    <div
                      key={index}
                      onClick={() => handlePlaceSelect(place)}
                      className="autocomplete-item"
                    >
                      <div className="place-name">{place.name}</div>
                      <div className="place-address">
                        {place.addressMain} {place.addressDetail}
                      </div>
                    </div>
                  ))}
                </div>
              )}
              <button onClick={handleAddPlace}>추가</button>
            </span>
          </li>
        </ul>
        <ListBody
          headers={headers}
          items={items}
          sort={sort}
          desc={desc}
          handleSortChange={handleSortChange}
          setSort={setSort}
          setDesc={setDesc}
          className="place_table"
        />
      </div>
    </div>
  );
};

export default TestingPlaceJoins;